import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import YesNoQuestionnaire from 'components/shared/YesNoQuestionnaire';
import { questions } from '../AssistedPassengerSelection.constants';
import { RadioButtonLegend } from '../AssistedPassengerSelection.styles';
import { noPassengers } from '../../../BookingMagnet.constants';

const EvacuationChairPassengerSelection = ({ onChangePassengers }) => (
  <YesNoQuestionnaire
    onAllAnswersSelected={(answers) => {
      onChangePassengers({
        ...noPassengers,
        [answers[questions.OLDER_THAN_TWELVE] ? 'adultsEvac' : 'childrenEvac']: 1
      });
    }}
    questions={[
      {
        name: questions.OLDER_THAN_TWELVE,
        legend: (
          <RadioButtonLegend>
            <FormattedMessage id="wheelchairSearch.questions.olderThanTwelve" />
          </RadioButtonLegend>
        )
      }
    ]}
  />
);

EvacuationChairPassengerSelection.propTypes = {
  onChangePassengers: PropTypes.func.isRequired
};

export default EvacuationChairPassengerSelection;
